(function () {
  if (window.__tmlTermsCheckoutGuardInit) return;
  window.__tmlTermsCheckoutGuardInit = true;

  var checkout_selector =
    '#cartform [name="checkout"]:submit, .additional-checkout-buttons :submit, ' +
    '.additional-checkout-buttons input[type=image], a[href="/checkout"]';

  // Capture-phase listener on document: fires before any bubble-phase
  // handler bound lower in the DOM (e.g. a script from WSH/WPD on <body>).
  // If terms aren't checked, the event is stopped here, so it never
  // reaches those handlers and never triggers their checkout redirect.
  document.addEventListener(
    "click",
    function (e) {
      var target = e.target.closest ? e.target.closest(checkout_selector) : null;
      if (!target) return;

      var terms = document.querySelector("#cartform input#terms");
      if (!terms || terms.checked) return;

      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();

      window.alert(
        (window.theme && theme.strings && theme.strings.cartConfirmation) ||
          "Please agree to the Terms & Conditions before checking out."
      );
    },
    true
  );
})();